import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import BenefirtsSection from "@components/Pages/One/BenefirtsSection/BenefirtsSection"
import OneUseCasesSection from "@components/Pages/One/OneUseCasesSection/OneUseCasesSection"
import OverviewFAQSection from "@components/Pages/One/OverviewFAQSection/OverviewFAQSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import Divider from "@components/WebsiteRevamp/Divider/Divider"
import ProductHero from "@components/WebsiteRevamp/Heros/ProductHero/ProductHero"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import One from "@jsons/one.json"
import NumberOneSection from "@pages/One/NumberOneSection/NumberOneSection"
import OneOverviewSection from "@pages/One/OneOverviewSection/OneOverviewSection"
import React from "react"

type Prodbo = {}

const overview = (prodbo: Prodbo) => {
	const pageData = getTranslatedPageData(One)
	const list = getValueOrThrow(pageData.AdvancedSideAsset)
	const subMenu = getValueOrThrow(pageData.subMenu)

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath="/products/one/overview"
			/>

			<section className={"one"}>
				<ProductHero
					theme={"oneDefault"}
					data={getValueOrThrow(pageData.heroData?.[0])}
				/>
			</section>

			<PageSubNavigation withCurve data={subMenu} />

			<OneOverviewSection data={list[0]} />
			<ContainerWrapper>
				<Divider />
			</ContainerWrapper>
			<BenefirtsSection data={list[1]} />
			<ContainerWrapper>
				<Divider />
			</ContainerWrapper>
			<section className={"one"} id={"solution"}>
				<Separator withoutMeasure>
					<OneUseCasesSection data={list[2]} />
				</Separator>
			</section>

			{/* <section className={"one"}>
				<OneUseCasesSection data={list[9]} />
			</section> */}
			{/* <ContainerWrapper>
				<Divider />
			</ContainerWrapper> */}
			<NumberOneSection data={list[10]} />
			<ContainerWrapper>
				<Divider />
			</ContainerWrapper>
			<OverviewFAQSection faq={getValueOrThrow(pageData.faqData)} />

			{/* 
			<ContainerWrapper>
				<OnePricingSection />
			</ContainerWrapper>
			<OneBenefitsSection data={list[1]} />
			<OneUseCasesSection data={list[2]} />
			<NumberOneSection data={list[3]} />

			<OneFormSection data={list[4]} /> */}
		</>
	)
}

export default overview
